import React, { useState } from 'react';
import SelectionIcon from '../../shared/components/SelectionIcon';
import PropTypes from 'prop-types';
import { usePopper } from 'react-popper';
import useOutsideClick from '../../shared/hooks/useOutsideClick';
import '../../shared/components/Filter.css';

const Filter = ({ ...props }) => {
  const [referenceElement, setReferenceElement] = useState(null);
  const [popperElement, setPopperElement] = useState(null);
  const [isPopperOpen, setIsPopperOpen] = useState(false);

  useOutsideClick([popperElement, referenceElement], () => setIsPopperOpen(false), isPopperOpen);

  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    placement: 'bottom-start',
  });

  const doChange = (e, value) => {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    setIsPopperOpen((prevState) => !prevState);
    if (props.multiple) {
      let index = -1;
      let newValue;
      if (props.value instanceof Array) {
        index = props.value.indexOf(value);
        newValue = props.value.slice();
      } else {
        newValue = [];
      }
      if (index >= 0) {
        newValue.splice(index, 1);
      } else {
        newValue.push(value);
      }
      if (typeof props.onChange === 'function') {
        props.onChange(newValue);
      }
    } else if (props.value !== value && typeof props.onChange === 'function') {
      props.onChange(value);
    }
  };

  const options = props.options || [];
  let caption;
  if (options.length > 0) {
    const optionList = [];

    if (options.length) {
      const selected = props.value || undefined;
      let i = 1;
      let selectedCount = 0;
      for (const option of options) {
        let isSelected = false;
        if (props.multiple) {
          if (selected instanceof Array) {
            isSelected = selected.indexOf(option.value) >= 0;
            if (isSelected) {
              selectedCount += 1;
              caption = option.label;
            }
          }
        } else {
          isSelected = option.value === selected;
          if (isSelected) {
            selectedCount += 1;
            caption = option.label;
          }
        }
        optionList.push(
          <a
            className={`filter-item ${isSelected ? 'checked' : ''}`}
            key={i}
            onClick={(e) => doChange(e, option.value)}
          >
            <SelectionIcon isSelected={isSelected} multiple={props.multiple} />
            {option.label}
          </a>
        );
        i += 1;
      }

      if (props.multiple && selected instanceof Array && selectedCount > 1) {
        caption = `${selectedCount} ${props.plural || 'items'}`;
      }

      return (
        <div className="Filter">
          <button
            ref={setReferenceElement}
            onClick={() => setIsPopperOpen((prevState) => !prevState)}
            aria-haspopup="true"
            aria-expanded="false"
          >
            {props.caption || caption || props.defaultCaption}
          </button>
          {isPopperOpen && (
            <div
              ref={setPopperElement}
              style={{ ...styles.popper }}
              {...attributes.popper}
              className="filter-menu"
            >
              {optionList}
            </div>
          )}
        </div>
      );
    }
  }
  return null;
};

Filter.propTypes = {
  id: PropTypes.string,
  multiple: PropTypes.bool,
  value: PropTypes.any,
  onChange: PropTypes.func,
  menuPlacement: PropTypes.string,
  options: PropTypes.array,
  plural: PropTypes.string,
  caption: PropTypes.string,
  defaultCaption: PropTypes.string,
};

export default Filter;
